module.exports = __webpack_public_path__ + "img/logo.4d82de6b.png";